{
  "version": 1,
  "asset_id": "6cc5460d-ae3c-4349-ae52-24e7d7fed64a",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6cc5460d-ae3c-4349-ae52-24e7d7fed64a/hernando-galvalume-metal-roof-destination-roofing-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6cc5460d-ae3c-4349-ae52-24e7d7fed64a/hernando-galvalume-metal-roof-destination-roofing-480w.webp",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-480w.webp",
  "size": 36188,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:53Z"
}
